var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrashcanIcon = function SvgTrashcanIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 26,
    fill: "currentColor",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h16v22H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M23.563 4.063h-5.956L16.25.813h-6.5l-1.357 3.25H2.437v1.625h2.438V22.75a2.437 2.437 0 0 0 2.438 2.438h11.375a2.437 2.437 0 0 0 2.437-2.438V5.688h2.438zM10.83 2.438h4.338l.675 1.624h-5.688zM19.5 22.75a.813.813 0 0 1-.812.813H7.313a.813.813 0 0 1-.813-.813V5.688h13zm-8.125-3.25H9.75V9.75h1.625zm4.875 0h-1.625V9.75h1.625z",
    clipRule: "evenodd"
  })));
};
export default SvgTrashcanIcon;